import React from 'react';
import PropTypes from 'prop-types';
import CoinsEvolution from './components/coins/CoinsEvolution';
import MyCoins from './components/coins/MyCoins';

function WalletCoinsContent({ filters }) {
  return (
    <div className="wallet-coins-content">
      <CoinsEvolution filters={filters} />
      <MyCoins filters={filters} />
    </div>
  );
}

WalletCoinsContent.propTypes = {
  filters: PropTypes.shape({
    startDate: PropTypes.number,
    endDate: PropTypes.number,
  }).isRequired,
};

export default WalletCoinsContent;
